(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sc-collection-vouchers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sc-voucher')) {
  customElements.define('sc-voucher', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const details = this.querySelector('details');
      const input = this.querySelector('input');
      const button = this.querySelector('button');
      const status = this.querySelector('[role="status"]');
      try {
        const saved = Number(localStorage.getItem(this.dataset.storageKey));
        details.open = saved > Date.now() - 86400000;
      } catch {}
      details.addEventListener('toggle', () => {
        try {
          if (details.open) localStorage.setItem(this.dataset.storageKey, String(Date.now()));
          else localStorage.removeItem(this.dataset.storageKey);
        } catch {}
      });
      input.addEventListener('click', () => input.select());
      button.addEventListener('click', async () => {
        let copied = false;
        try {
          await navigator.clipboard.writeText(input.value);
          copied = true;
        } catch {
          input.focus();
          input.select();
          try { copied = document.execCommand('copy'); } catch {}
        }
        button.textContent = copied ? this.dataset.copied : this.dataset.copy;
        status.textContent = copied ? this.dataset.copied : this.dataset.manual;
        if (!copied) { input.focus(); input.select(); }
        clearTimeout(this.copyTimer);
        this.copyTimer = setTimeout(() => { button.textContent = this.dataset.copy; }, 2200);
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
